import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import { useIntl } from '@doxyme/locale';
import { modalClasses } from '../modal.classes';
import { useModalHeaderStyles } from './modalHeader.styles';
import { IconButton } from '@doxyme/ui-foundation/components/iconButton';
import { Icon } from '@doxyme/icons';
import { BodyM, Heading } from '@doxyme/ui-foundation/typography';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { InfoIcon } from '@doxyme/ui-foundation/components/infoIcon';
import { useViewport } from '@doxyme/ui-foundation/hooks';
/**
 * Renders the title and subtitle for the Modal at the top. Has to be placed within `<ModalContent>`
 */ export const ModalHeader = ({ title, titleId, styles, subtitle, icon, infoIcon, hasMultiLineSubtitle = false, onClose })=>{
    const { formatMessage } = useIntl();
    const css = useModalHeaderStyles({
        isEmpty: !Boolean(title) && !Boolean(subtitle) && !Boolean(icon),
        hasMultiLineSubtitle
    });
    const theme = useTheme();
    const { isSmallViewport } = useViewport();
    return /*#__PURE__*/ _jsx(Box, {
        css: css.container,
        className: modalClasses.header,
        style: styles?.header,
        children: /*#__PURE__*/ _jsxs(Box, {
            css: css.innerContainer,
            children: [
                Boolean(icon) && /*#__PURE__*/ _jsx(Box, {
                    css: css.iconContainer,
                    children: icon
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    css: css.titleContainer,
                    children: [
                        Boolean(title) && /*#__PURE__*/ _jsx(Heading, {
                            tag: "h2",
                            variant: "titleH4",
                            id: titleId,
                            className: modalClasses.title,
                            fontWeight: "medium",
                            css: {
                                ...css.title,
                                ...styles?.title
                            },
                            children: title
                        }),
                        Boolean(subtitle) && /*#__PURE__*/ _jsxs(Box, {
                            css: css.subtitle,
                            children: [
                                /*#__PURE__*/ _jsx(BodyM, {
                                    color: theme.text.generic.tertiary,
                                    children: subtitle
                                }),
                                Boolean(infoIcon) && /*#__PURE__*/ _jsx(InfoIcon, {
                                    ...infoIcon
                                })
                            ]
                        })
                    ]
                }),
                Boolean(onClose) && /*#__PURE__*/ _jsx(IconButton, {
                    type: "subtle",
                    size: "medium",
                    title: formatMessage({
                        id: 'close'
                    }),
                    className: modalClasses.closeButton,
                    onClick: ()=>onClose?.(),
                    css: {
                        ...styles?.closeButton
                    },
                    tooltipPlacement: isSmallViewport ? 'left' : undefined,
                    icon: /*#__PURE__*/ _jsx(Icon.Close, {
                        color: theme.icon.primary,
                        className: modalClasses.closeIcon,
                        style: styles?.closeIcon
                    })
                })
            ]
        })
    });
};

//# sourceMappingURL=modalHeader.js.map